/**
 * Converts an image URL to its thumbnail variant
 * The backend generates thumbnails with "_thumbnail" suffix before the extension
 * e.g., "gs://bucket/path/image.jpg" → "gs://bucket/path/image_thumbnail.jpg"
 */
export function getThumbnailUrl(url: string): string {
  if (!url) return url;
  // Insert _thumbnail before the file extension
  return url.replace(/(\.[^.]+)$/, '_thumbnail$1');
}
